import React, { useContext } from 'react';
import { usePasswordReset } from '../hooks/usePasswordReset';
import { FormStatus } from '../util/app.types';
import { Tr8Context } from '../App';
import ValidationMessage from '../components/ValidationMessage';

export type AppProps = {};

function escapeAsHtmlText(text: string): string {
  const escapeMap: Map<string, string> = new Map<string, string>([
    ['&', '&amp;'],
    ['<', '&lt;'],
    ['>', '&gt;'],
    ['"', '&quot;'],
    ["'", '&#39;'],
  ]);

  return text.replace(/[&<>"']/g, (match) => escapeMap.get(match)!);
}

export const RequestResetPassword = (): JSX.Element => {
  const tr8 = useContext(Tr8Context);
  const { formStatus, submit, invalidEmailWarning, mail } = usePasswordReset();
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    submit((e.currentTarget.elements[0] as HTMLInputElement).value);
  };

  const showForm =
    formStatus === FormStatus.Editing || formStatus === FormStatus.InFlight;
  return (
    <>
      {showForm && (
        <form onSubmit={handleSubmit} className="formContainer">
          <input
            data-test-id="request-reset-password-email"
            type="text"
            id="mail"
            name="mail"
            placeholder="email"
            autoComplete="off"
            className="form-field"
            disabled={formStatus === FormStatus.InFlight}
          />
          <input
            data-test-id="request-reset-password-submit"
            type="submit"
            value="Submit"
            className="submit-button"
            disabled={formStatus === FormStatus.InFlight}
          />
          {invalidEmailWarning && (
            <ValidationMessage msg={tr8('invalid-email')} />
          )}
        </form>
      )}
      {formStatus === FormStatus.Succeeded && (
        <form
          className="formContainer--close-tab"
          dangerouslySetInnerHTML={{
            __html: tr8(
              'close-tab',
              new Map([['EMAIL', String(escapeAsHtmlText(mail))]]),
            ),
          }}
        ></form>
      )}
      {formStatus === FormStatus.Failed && (
        <form className="formContainer">{tr8('something-went-wrong')}</form>
      )}
    </>
  );
};
